const INITIAL_STATE = {
	tipo: null,
};

// eslint-disable-next-line default-param-last
export function layout(state = INITIAL_STATE, action) {
	switch (action.type) {
		case '@auth/SET_LAYOUT':
			return {
				...state,
				tipo: action.payload.tipo,
			};

		default:
			return state;
	}
}
